import script from "./SheetForeignPasiveFinancing.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetForeignPasiveFinancing.vue?vue&type=script&setup=true&lang=ts"

import "./SheetForeignPasiveFinancing.vue?vue&type=style&index=0&id=51d60858&lang=css"

const __exports__ = script;

export default __exports__